<template>
<div>
	<form-selector-breadcrumb
		:category-selected="localCategorySelected"
		:template-selected="localTemplateSelected"
		v-on:deselectCategory="deselectCat"
		v-on:deselectTemplate="deselectTemplate">
	</form-selector-breadcrumb>

	<div v-if="!localCategorySelected" class="list-group">
		<button v-for="cat in $store.companyFormTemplateCategories" 
			v-if="!worksheetFormsOnly || cat.has_worksheet_forms == 1"
			class="list-group-item list-group-item-action"
			type="button" 
			:key="cat.id+'_'+cat.name"
			v-on:click="selectCat(cat)">
			{{cat.name}}
		</button>
		<p v-if="$store.companyFormTemplateCategories.length == 0">No template categories created</p>
	</div>
	<div v-else-if="!localTemplateSelected">
		<div class="list-group">
			<button v-for="template in templates" 
				v-if="!worksheetFormsOnly || template.is_worksheet_form == 1"
				class="list-group-item list-group-item-action"
				:class="{disabled: !userCanUseTemplate(template)}"
				type="button" 
				:key="template.name"
				v-on:click="selectTemplate(template)">
				<div class="d-flex flex-row justify-content-between">
					{{template.title}} <span v-if="!userCanUseTemplate(template)" class="text-muted">You don't have permission to use this form</span>
				</div>
			</button>
		</div>
		<p v-if="templates.length == 0">No form templates found in <strong>{{ localCategorySelected.name }}</strong>. <span v-if="showCreateLinks"> <a href="#" v-on:click.prevent="addTemplate"> Create one</a> now.</span></p>
	</div>
	<div v-else>
		
		<div class="list-group mt-2">
			<button v-for="childTemplate in childTemplates" 
				type="button" 
				class="list-group-item list-group-item-action"
				v-on:click="$emit('childTemplateClick',childTemplate)">
				
				<div class="d-flex flex-row justify-content-between flex-wrap">
					<div>{{childTemplate.description}}</div>
				</div>

			</button>
			<p v-if="childTemplates.length == 0">No child templates created from this <strong>{{ localTemplateSelected.name }}</strong> template. <span v-if="showCreateLinks"> <a href="#" v-on:click.prevent="addChildTemplate"> Create one</a> now.</span></p>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
import FormSelectorBreadcrumb from "@/components/company_forms/FormSelectorBreadcrumb"

import FormMixins from "@/mixins/FormMixins.js"

export default {
	name: "FormChildTemplateSelector",
	components: {
		FormSelectorBreadcrumb
	},
	mixins: [FormMixins],
	props: [
		"value",
		"showCreateLinks",
		"categorySelected",
		"templateSelected",
		"categorySlug",
		"templateSlug",
		"projectId",
		"serviceId",
		"worksheetFormsOnly"
	],
	data() {
		return {
			localCategorySelected: null,
			localTemplateSelected: null,
			templates: [],
			childTemplates: [],
			childTemplateSelectedId: null,
			forms: [],
			userRoleIds: []
		}
	},
	watch: {
		value() {
			this.init()
		},
		categorySelected() {
			this.localCategorySelected = this.categorySelected
		},
		templateSelected() {
			this.localTemplateSelected = this.templateSelected
		}
	},
	methods: {
		init() {
			let vm = this
			this.childTemplateSelectedId = this.value

			this.fetchTemplateCategories(true).then(response => {
				if (response.success)
					vm.$emit("categoriesFetched",response.data)
				
				if (vm.categorySlug) {
					vm.selectCat(vm.$store.companyFormTemplateCategories.find(cat => cat.name.slugify() == vm.categorySlug)).then(response => {
						if (vm.templateSlug) 
							vm.selectTemplate(vm.templates.find(temp => temp.title.slugify() == vm.templateSlug))
						
					})
				}
			})

			let jobType, jobId
			if (this.projectId > 0) {
				jobType = "project"
				jobId = this.projectId
			}
			else if (this.serviceId > 0) {
				jobType = "service"
				jobId = this.serviceId
			}

			this.fetchUserRoles(this.$store.userDetails.id,jobType,jobId).then(response => {
				if (response.success)
					vm.userRoleIds = response.data.map(record => record.personnel_role_id)
					
			})
		},
		userCanUseTemplate(template) {
			let vm = this

			if (!this.serviceId && !this.projectId)
				//we're in the main forms module, don't enforce editing rights
				return true;

			if (this.hasModulePermWrite("Company Forms"))
				return true

			if (!("JobPersonnelRole" in template))
				return true
			if (!template.JobPersonnelRole)
				return true

			if (template.JobPersonnelRole.length == 0)
				return true

			if (this.serviceId > 0 && this.$store.service && this.$store.userDetails.id == this.$store.service.assigned_to)
				return true

			let hasRole = template.JobPersonnelRole.find(templateRole => vm.userRoleIds.indexOf(templateRole.id) >= 0)

			return hasRole
		},
		selectCat(cat) {
			let vm = this
			
			return new Promise((resolve,reject) => {
				if (cat) {
					vm.localCategorySelected = cat

					vm.$emit("categorySelected",cat)
					vm.$emit("categoryChange",cat)

					let include = [
						{
							model:"JobPersonnelRole",
							fields:["id","slug","title"]
						}
					]

					vm.fetchTemplates({
							cat_id: cat.id,
							include
						})
						.then(response => {
							if (response.success)
								vm.$emit("templatesFetched",response.data)

							resolve(response)
						})
				}
				else
					resolve(null)
			})
		},
		deselectCat() {
			this.localCategorySelected = false
			this.localTemplateSelected = false
			
			this.$emit("categoryDeselected")
			this.$emit("categoryChange",false)
		},
		selectTemplate(template) {
			let vm = this
			
			return new Promise((resolve,reject) => {
				if (template) {
					vm.localTemplateSelected = template

					vm.$emit("templateSelected",template)
					vm.$emit("templateChange",template)

					vm.fetchChildTemplates(template.id).then(response => {
						if (response.success) {
							vm.childTemplates = response.data
							vm.$emit("childTemplatesFetched",response.data)
						}

						resolve(response)
					})
				}
				else
					resolve(null)
			})
		},
		deselectTemplate() {
			this.localTemplateSelected = false

			this.$emit("templateDeselected")
			this.$emit("templateChange",false)
		},
		addTemplate() {
			this.$router.push("/forms/template-editor/"+this.categorySelected.name.slugify()+"/new")
		},
		addChildTemplate() {
			this.$router.push("/forms/child-template-editor/"+this.templateSelected.title.slugify()+"/new")
		}
	},
	created() {
		this.init()
	}
}
</script>

<style scoped>

div p {
	margin-left: 15px;
}
</style>